export const stripeErrors: Record<
  string,
  { title: string; message: (error: { message: string }) => string }
> = {
  api_connection_error: {
    title: 'Connection Error',
    message: () =>
      'We’re having trouble connecting to our payment processor. Please try again later.',
  },
  api_error: {
    title: 'API Error',
    message: () =>
      'We’re experiencing some technical issues. Please try again later or contact support if the problem persists.',
  },
  authentication_error: {
    title: 'Authentication Error',
    message: () =>
      'Authentication with our payment service failed. Please report this issue.',
  },
  card_error: {
    title: 'Card Error',
    // Here, we define a function to dynamically generate the message using `error.message`
    message: (error) =>
      `${error.message}. Please try again with a different card.`,
  },
  idempotency_error: {
    title: 'Idempotency Error',
    message: () =>
      'A network error occurred. Please try submitting your payment again.',
  },
  invalid_request_error: {
    title: 'Invalid Request',
    message: () =>
      'Your request is invalid. Please refresh the page and try again.',
  },
  rate_limit_error: {
    title: 'Rate Limit Exceeded',
    message: () =>
      'We’re experiencing high traffic. Please wait a moment and try your request again.',
  },
  validation_error: {
    title: 'Validation Error',
    message: () =>
      'The information submitted was invalid. Please check your inputs and try again.',
  },
}
